const STORAGE_PREFIX = "halo:login-lockout:";

function storageKey(email) {
  return `${STORAGE_PREFIX}${String(email || "").trim().toLowerCase()}`;
}

/**
 * @param {string} email
 * @returns {number | null} lockout end timestamp (ms), or null
 */
export function readStoredLoginLockout(email) {
  if (typeof window === "undefined" || !email?.trim()) {
    return null;
  }
  try {
    const raw = window.sessionStorage.getItem(storageKey(email));
    if (!raw) {
      return null;
    }
    const until = Number(raw);
    if (!Number.isFinite(until) || until <= Date.now()) {
      window.sessionStorage.removeItem(storageKey(email));
      return null;
    }
    return until;
  } catch {
    return null;
  }
}

/**
 * @param {string} email
 * @param {number} lockoutUntilMs
 */
export function storeLoginLockout(email, lockoutUntilMs) {
  if (typeof window === "undefined" || !email?.trim() || !lockoutUntilMs) {
    return;
  }
  try {
    window.sessionStorage.setItem(storageKey(email), String(lockoutUntilMs));
  } catch {
    // ignore quota / private mode
  }
}

/**
 * @param {string} email
 */
export function clearStoredLoginLockout(email) {
  if (typeof window === "undefined" || !email?.trim()) {
    return;
  }
  try {
    window.sessionStorage.removeItem(storageKey(email));
  } catch {
    // ignore
  }
}
